var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},_vm._l((_vm.contentMessages),function(message){return _c('div',{key:message.id,class:['message', {
				warning: message.status != 'ready' && message.status != 'sent',
				success: message.status === 'sent'
			}]},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.formatDate(message.time),"placement":"top"}},[(message.status != 'ready')?_c('i',{class:{
		  		  'unverified': 'el-icon-warning',
		  		  'sent': 'el-icon-success'
		  	  }[message.status]}):_vm._e()])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }